import {ViewCell} from '@mominsamir/ngx-smart-table';
import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Params} from '@angular/router';
import {NbTooltipDirective, NbTrigger} from '@nebular/theme';

@Component({
    selector: 'ngx-link-cell',
    template: `
        <a
            *ngIf="value && value !== '/'"
            [routerLink]="routerLink(rowData)"
            [queryParams]="queryParams(rowData)"
            (click)="onNavigationClicked.emit(rowData)"
            (mouseenter)="showTooltip()"
            (mouseleave)="closeTooltip()"
            [nbTooltip]="tooltip(rowData)"
            [nbTooltipTrigger]="NbTrigger.NOOP"
        >
            {{ value }}
        </a>
    `,
    styleUrls: ['./link-cell.component.scss'],
})
export class LinkCellComponent implements ViewCell {
    @ViewChild(NbTooltipDirective, {static: false}) tooltipDirective: NbTooltipDirective;
    readonly NbTrigger = NbTrigger;

    @Input() value: any;
    @Input() rowData: any;

    @Output() onNavigationClicked: EventEmitter<any> = new EventEmitter();

    routerLink = (rowData: any): string => './';
    queryParams = (rowData: any): Params | null => null;

    tooltip = (rowData: any): string => '';

    showTooltip() {
        if (this.tooltip(this.rowData)) this.tooltipDirective.show();
    }

    closeTooltip() {
        if (this.tooltip(this.rowData) && this.tooltipDirective.isShown) this.tooltipDirective.hide();
    }
}
